<template>
  <div id="app">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 px-4">Instellingen</h1>
    </div>

    <div id="instellingen" class="container-fluid px-4">
      <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a
            class="nav-item nav-link active"
            id="nav-home-tab"
            data-toggle="tab"
            href="#nav-home"
            role="tab"
            aria-controls="nav-home"
            aria-selected="true"
            >Mail (Levering)</a
          >
          <a
            class="nav-item nav-link"
            id="nav-profile-tab"
            data-toggle="tab"
            href="#nav-profile"
            role="tab"
            aria-controls="nav-profile"
            aria-selected="false"
            >Mail (Ophaling)</a
          >
          <a
            class="nav-item nav-link"
            id="nav-signature-tab"
            data-toggle="tab"
            href="#nav-signature"
            role="tab"
            aria-controls="nav-signature"
            aria-selected="false"
            >Handtekening</a
          >
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <label>Onderwerp</label>
          <input type="text" class="form-control" v-model="instellingen.intro_mail_onderwerp" />
          <br />

          <!--
          <label>Bericht</label>
          <textarea
            class="form-control"
            v-model="instellingen.intro_mail_bericht"
          ></textarea>
          <br />
          -->

          <label>Bericht</label>
          <vue-editor :editorToolbar="customToolbar" v-model="instellingen.intro_mail_bericht"></vue-editor>
          <br />

          <label>Bijlagen</label>
          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                multiple
                type="file"
                class="custom-file-input"
                id="inputIntro"
                ref="introFiles"
                @change="selectIntroFiles"
              />
              <label class="custom-file-label" for="inputIntro">Kies bestand(en)</label>
            </div>
          </div>
          <p>{{ introUploadFeedback }}</p>
          <ul v-if="instellingen.intro_mail_bijlagen.length > 0">
            <li v-for="file in instellingen.intro_mail_bijlagen" :key="file.id">
              <a target="_blank" :href="file">{{ file.name ? file.name : file | filename }}</a>
            </li>
          </ul>
        </div>
        <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
          <label>Onderwerp</label>
          <input type="text" class="form-control" v-model="instellingen.ophaling_mail_onderwerp" />
          <br />

          <!--
          <label>Bericht</label>
          <textarea
            class="form-control"
            v-model="instellingen.ophaling_mail_bericht"
          ></textarea>
          <br />
          -->

          <label>Bericht</label>
          <vue-editor :editorToolbar="customToolbar" v-model="instellingen.ophaling_mail_bericht"></vue-editor>
          <br />

          <label>Bijlagen</label>
          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                multiple
                type="file"
                class="custom-file-input"
                id="inputOphaling"
                ref="ophalingFiles"
                @change="selectOphalingFiles"
              />
              <label class="custom-file-label" for="inputOphaling">Kies bestand(en)</label>
            </div>
          </div>
          <p>{{ ophalingUploadFeedback }}</p>
          <ul v-if="instellingen.ophaling_mail_bijlagen.length > 0">
            <li v-for="file in instellingen.ophaling_mail_bijlagen" :key="file.id">
              <a target="_blank" :href="file">{{ file.name ? file.name : file | filename }}</a>
            </li>
          </ul>
        </div>
        <div class="tab-pane fade" id="nav-signature" role="tabpanel" aria-labelledby="nav-signature-tab">
          <label>Handtekening zaakvoerder</label>
          <div class="signatureContainer">
            <VPerfectSignature
              width="500"
              height="150"
              style="width:500px !important;"
              :stroke-options="strokeOptions"
              ref="signaturePad"
            />
          </div>
          <button type="button" class="btn btn-secondary" v-on:click="clear()">
            Opnieuw
          </button>
          <br />
        </div>
      </div>
      <hr />

      <button type="button" class="btn btn-primary mb-5" v-on:click="updateInstellingen()">
        Opslaan
      </button>
    </div>
  </div>
</template>

<script>
import "bootstrap";
import axios from "axios";
import { VueEditor } from "vue2-editor";
import VPerfectSignature from "v-perfect-signature";

export default {
  name: "app",
  components: {
    VueEditor,
    VPerfectSignature,
  },
  filters: {
    filename(val) {
      if (val) {
        return val.substring(val.toString().lastIndexOf("/") + 1);
      }
    },
  },
  data() {
    return {
      strokeOptions: {
        size: 4,
        thinning: 0,
        smoothing: 0.5,
        streamline: 0.5,
      },
      showSignaturePad: false,
      instellingen: {},
      intro_mail: {
        onderwerp: "",
        bericht: "",
        bijlagen: "",
      },
      inputIntroFiles: [],
      inputOphalingFiles: [],
      introUploadFeedback: "",
      ophalingUploadFeedback: "",
      uploadFiles: [],
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ font: [] }],
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ["small", false, "large", "huge"] }],
        [{ color: [] }],
      ],
    };
  },
  mounted() {
    this.getInstellingen();

    this.$nextTick(() => {
      setTimeout(() => {
        const tab = document.getElementById("nav-signature") || this.$refs.signatureTab;
        if (tab) {
          const callback = (mutationsList) => {
            for (let mutation of mutationsList) {
              if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class" &&
                tab.classList.contains("active")
              ) {
                console.log("Signature tab is now visible!");
                this.$refs.signaturePad.fromDataURL(this.instellingen.handtekening);
                this.$refs.signaturePad.resizeCanvas(true);
              }
            }
          };

          this.observer = new MutationObserver(callback);
          this.observer.observe(tab, { attributes: true });
        } else {
          console.error("Element still not found!");
        }
      }, 500); // Wait for 500ms. Adjust this time if needed.
    });
  },
  methods: {
    selectIntroFiles() {
      var files = this.$refs.introFiles.files;
      var filesArray = [];
      this.inputIntroFiles = [];

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      for (let i = 0; i < files.length; i++) {
        let file = this.$refs.introFiles.files.item(i);

        toBase64(file).then((res) => {
          console.log({ name: file.name, path: res });
          filesArray.push({ name: file.name, path: res });
        });

        this.inputIntroFiles.push(file.name);
      }

      this.introUploadFeedback = this.inputIntroFiles.length + " bestand(en) klaar voor upload...";

      this.instellingen.intro_mail_bijlagen = filesArray;
    },
    clear() {
      this.$refs.signaturePad.clear();
    },
    selectOphalingFiles() {
      var files = this.$refs.ophalingFiles.files;
      var filesArray = [];
      this.inputOphalingFiles = [];

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });

      for (let i = 0; i < files.length; i++) {
        let file = this.$refs.ophalingFiles.files.item(i);

        toBase64(file).then((res) => {
          filesArray.push({ name: file.name, path: res });
        });

        this.inputOphalingFiles.push(file.name);
      }

      this.ophalingUploadFeedback = this.inputOphalingFiles.length + " bestand(en) klaar voor upload...";

      this.instellingen.ophaling_mail_bijlagen = filesArray;
    },
    getInstellingen() {
      axios
        .get("https://hofman.weblion.be/api/instellingen/")
        .then((response) => {
          this.instellingen = response.data;
          console.log(this.instellingen);
        })
        .catch((error) => console.log(error));
    },
    updateInstellingen() {
      console.log(this.instellingen);
      const dataURL = this.$refs.signaturePad.toDataURL();
      this.instellingen.handtekening = dataURL;
      axios
        .put("https://hofman.weblion.be/api/instellingen/", {
          instellingen: this.instellingen,
          handtekening: dataURL,
        })
        .then((response) => {
          console.log(response.data);
          this.getInstellingen();
          this.introUploadFeedback = "";
          this.ophalingUploadFeedback = "";
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}

button {
  margin-right: 10px;
}

.date {
  margin-left: 6px;
  color: #999;
}

.table thead th {
  text-align: left !important;
}

.pager ul {
  list-style-type: none;
}

.pager ul li {
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}

.modal input,
.modal select {
  margin-bottom: 5px;
}

.modal label {
  display: inline-block;
  width: 32%;
}

.modal .form-control {
  display: inline-block;
  width: 68%;
}

.modal-body select {
  text-indent: 5px;
}

#instellingen textarea {
  height: 300px !important;
}

#agenda {
  margin-top: 50px;
}

#exampleModal input {
  display: block;
  width: 100%;
}

.dropdown {
  display: inline-block;
}

.dropdown-item:hover {
  cursor: pointer !important;
}

.dropdown-item i {
  margin-right: 3px;
}

/*
.sticky-nav {
  position: fixed;
  height: 150px;
  top: 50;
  z-index: 2;
  background: white;
  padding-top: 10px;
  width: 100%;
  margin-top: -10px;
}
*/

.o-item:hover {
  cursor: pointer;
}

.vgt-wrap {
  margin-top: 120px;
}

label {
  vertical-align: top;
}

[data-g="1"] {
  background: #8cc040;
}

[data-g="0"] {
  background: red;
}

.tab-pane input,
.tab-pane textarea,
.tab-pane .input-group,
.quillWrapper {
  width: 68%;
}

.signatureContainer {
  width: 500px;
  height: 150px;
}

.signatureContainer canvas {
  width: 500px !important;
  height: 150px !important;
}
</style>
